import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

export type PageIsNotAvailable = Record<
    string,
    {
        pageName: string;
        link: string;
    }
>;

export default autoGeneratedReducer<PageIsNotAvailable>(null);
